import { cmds } from "effects";

export function* setup() {
  const paths = yield cmds.rpc("ListAbuseReports", {
    page: 0,
    pageLength: 1000
  });
  yield cmds.setState("abuseReports.list", paths);
}
